import React, { useState } from 'react';
import { DEFAULT_OWNERSHIP_VALUE } from './const';
import RawInput from '../RawInput';

export default function PercentOwnership({
  onChange,
}: {
  onChange: (percentOwnership: number) => void;
}): JSX.Element {
  const [internalValue, setInternalValue] = useState(DEFAULT_OWNERSHIP_VALUE);
  return (
    <div className='md:w-1/3 my-2'>
      <RawInput
        name='kycPercentOwnership'
        label='Percent Ownership'
        id='kycPercentOwnership'
        type='number'
        onChange={(e): void => {
          if (e.target?.value !== `${internalValue}`) {
            const valueNumber = parseFloat(e.target.value);
            setInternalValue(valueNumber);
            onChange(valueNumber);
          }
        }}
        required={true}
        value={`${internalValue}`}
      />
    </div>
  );
}
